export const VIOLATION_STATS_URL = "/api/dashboard/stats";
export const VIOLATION_GRAPH_URL = "/api/dashboard/graphstats";
export const VIOLATION_RECENT_IMAGE_URL = "/api/dashboard/dashboardimage";
export const VIOLATION_RECENT_IMAGE_URL_NEW = "/api/dashboard/dashboardimage/new";
export const AREA_LIST_URL = "/api/area/list";
export const VIOLATION_TREND_URL = "/api/dashboard/trends";
export const AREA_VIOLATION = "/api/dashboard/areaviolation";
export const FETCH_INSTANCE_LIST = "/api/dashboard/instance";
export const FETCH_AI_MODEL = '/api/dashboard/ai-models';
export const FETCH_SESSION_DATA = '/api/dashboard/session';
export const FETCH_SINGLE_USER_DATA = '/api/dashboard/session-violations';
export const FETCH_TIMELINE_VIOLATIONS = '/api/dashboard/monitoring/timeline/violations'